import { Component } from 'react';
import PropTypes from 'prop-types';
import staticHypotheekbondUrl from '../../../../helper/hypotheekbondUrl';
import hstatic from '../../../../helper/hstatic';
import ReactSVG from 'react-svg';

class MessageBoxComponent extends Component {
  render() {
    const { open, type, closeable, onCloseHandler } = this.props;

    if (!open) {
      return null;
    }

    let classNames = 'message-box';

    if (type) {
      classNames += ` ${type}`;
    }

    if (!closeable) {
      classNames += ' not-closeable';
    }

    const svgPath = hstatic(`${staticHypotheekbondUrl()}/images/icon/cross.svg`);

    let closeButton = '';
    if (closeable) {
      closeButton = (
        <button className="close" onClick={onCloseHandler} type="button">
          <ReactSVG path={svgPath} svgClassName="sd" />
        </button>
      );
    }

    return (
      <div className={classNames}>
        {closeButton}
        <p>{this.props.children}</p>
      </div>
    );
  }
}

MessageBoxComponent.propTypes = {
  onCloseHandler: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  closeable: PropTypes.bool.isRequired,
  children: PropTypes.node,
  type: PropTypes.oneOf(['success', 'info', 'danger', 'warning']),
};

MessageBoxComponent.defaultProps = {
  onCloseHandler: () => {
  },
  open: false,
  closeable: true,
  children: null,
  type: 'info',
};

export default MessageBoxComponent;
